import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

export function usePageTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    // Don't track the stats page itself
    if (path === '/stats') return;

    fetch(`${API}/api/stats/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        path,
        referrer: document.referrer || null
      })
    }).catch(() => {});
  }, [location.pathname]);
}
